const highlightedHeaderTokens = (lineHeights, fontSizes) => ({
  lineHeights: {
    small: lineHeights.bodies.xSmall,
    full: lineHeights.headings[5],
  },
  fontSizes: {
    full: fontSizes.headings[5],
  },
});

export default highlightedHeaderTokens;
